import { getOrgGoalCategories } from "api";
import { useQuery } from "react-query";

const useGoalsQuery = (orgId) => {
  const { data, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ["organization", orgId, "goalsCategories"],
    queryFn: () => {
      const goals = getOrgGoalCategories(orgId);
      return goals;
    },
    enabled: Boolean(orgId),
    refetchOnWindowFocus: false,
  });
  return { data, isLoading, isError, refetch, isFetching };
};

export default useGoalsQuery;
